import React from "react";

import { useGetDeviceType }   from "_common/hooks/global";
import { LIVESESSION, VIDEO } from "_common/utils/index.js";
import Divider                from "_components/atoms/divider/index.js";
import Typography             from "_components/atoms/typography";
import VideoCard              from "_components/organisms/videoCardList/videoCard";

import MobileVideoCard from "./component/mobileVideoCard";
import useStyles       from "./styles.js";

const formatVideoList = ( list = [] ) => {

	return list.map ( item => {
		// separate handling for different structure of response from api
		if ( item.feed_type?.includes ( "VIDEOS" ) ) {

			return {
				id        : item?.id,
				createdAt : item?.created_at,
				endedAt   : item?.endTimeUTC,
				title     : item?.title,
				isLive    : false,
				userData  : {
					id          : item?.actorDetails?.id,
					name        : item?.actorDetails?.name,
					photo       : item?.actorDetails?.photo,
					isCeleb     : item?.actorDetails?.isCeleb,
					isFollowing : item?.actorDetails?.isFollowing
				},
				thumbnail     : item?.media[1]?.href,
				src           : item?.cdnUrl,
				feedType      : VIDEO,
				videoDuration : item?.read_time,
				views         : item?.views, // totalViews, views are already there, not confirm which one should be used
				reactions     : item?.reactions,
				sharesCount   : item?.shares_count,
				commentsCount : item?.comment_count
			};

		}

		return {
			id        : item?.id,
			createdAt : item?.startTimeUTC,
			endedAt   : item?.endTimeUTC,
			title     : item?.sessionInfo,
			isLive    : !item?.endTimeUTC,
			userData  : {
				id          : item?.broadcaster?.sportsFan?.id,
				name        : item?.broadcaster?.sportsFan?.name,
				photo       : item?.broadcaster?.sportsFan?.photo,
				isCeleb     : item?.broadcaster?.sportsFan?.isCeleb,
				isFollowing : item?.broadcaster?.sportsFan?.isFollowing
			},
			thumbnail     : item?.thumbnail,
			src           : item?.cdnUrl,
			feedType      : item?.feed_type?.includes ( "VIDEOS" ) ? VIDEO : LIVESESSION,
			views         : !item?.endTimeUTC ? item?.liveViews : item?.views, // totalViews, views are already there, not confirm which one should be used
			reactions     : item?.totalReactions,
			sharesCount   : item?.shares_count,
			commentsCount : item?.comment_count
		};
	} );
};

const component = ( { name, videoList } ) => {
	const formattedVideoList = formatVideoList ( videoList );

	const { classes } = useStyles ( );

	const heading = "Latest from  ";

	const deviceType = useGetDeviceType ();
	const isMobile   = deviceType === "mobile";

	return (
		<>
			<div className = { classes.popularContentWrapper }>
				<div className = { classes.headerWrapper }>
					<Typography
						className = { classes.heading }
						title     = { heading }
					/>

					<Typography
						className = { classes.name }
						title     = { name }
					/>
				</div>

				{isMobile ? (
					<div className = { classes.mobileVideosContainer }>
						{formattedVideoList.map ( data => (
							<MobileVideoCard
								key  = { data.id }
								data = { data }
							/>
						)
						)}
					</div>
				) : (
					<div className = { classes.horizontalVideosContainer }>
						{
							formattedVideoList.map ( item => {
								return (
									<VideoCard
										key       = { item.id }
										hideMenuOptions
										isWithoutAnimation
										activeTab = { "" }
										data      = { item }
										from      = ""
									/>
								);
							} )
						}
					</div>
				)}

			</div>

			<Divider />
		</>
	);

};

export default component;
